<app-breadcrumb *ngIf="!UsedBySelector" [lablPage]="'items-requests.Items Requests'|translate"
    [breadcrumbItemsList]="[{title:'items-requests.Dashboard',url:'/admin'},{title:'items-requests.Items Requests',url:'/admin/requests'}]"></app-breadcrumb>

<div class="auction_items mb-4">
    <!-- <h3>{{title|titlecase}}</h3> -->
    <div class="d-flex justify-content-center align-items-center">
        <div class="filter_list">
            <div class="filter_item" [class.active]="item.key == RequestListModal.status" (click)="onSelectType(item,i)"
                matRipple *ngFor="let item of FilterItems;let i=index">
                <span class="text">{{item.value|translate}}</span> <span class="count mx-2">{{item.count}}</span>
            </div>

        </div>
    </div>

    <div class="tableHeader container-fluid">
        <!-- <div class="row">
            <div class="col-xl-6 clo-md-6 col-sm-6 col-12 sort">
                <p class="d-inline"> <span class="total">{{total}}</span>
                    <span [ngSwitch]="RequestListModal.status">
                        <span *ngSwitchCase="'new'">
                            {{'items-requests.New' | translate}}
                        </span>
                        <span *ngSwitchCase="'approved'">
                            {{'bidders.Approved' | translate}}
                        </span>
                        <span *ngSwitchCase="'rejected'">
                            {{'bidders.Declined' | translate}}
                        </span>
                    </span>
                    {{'items-requests.Request' | translate}}

                </p>
                <div class="d-inline">
                    {{'filter.sortBy' | translate}}:

                    <button mat-button class="btnLight_fill" [matMenuTriggerFor]="menu">{{sortByText|translate}} <svg
                            xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5">
                            <path id="arrow"
                                d="M15.5,9.112a.9.9,0,0,0-1.2,0l-3.065,2.834L8.211,9.112a.9.9,0,0,0-1.2,0,.766.766,0,0,0,0,1.137l3.62,3.394a.894.894,0,0,0,1.212,0L15.5,10.249a.766.766,0,0,0,0-1.137Z"
                                transform="translate(-6.754 -8.879)" fill="#70639e" />
                        </svg>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item *ngFor="let item of sortingList" (click)="OnSelectSort(item)">{{item.key
                            |translate}}</button>
                    </mat-menu>
                </div>
            </div>
            <div class="col-xl-6 clo-md-6 col-sm-6 col-12 filter_search">
                <div class="d-inline-flex align-items-center">
                    <a (click)="showSearch=!showSearch;RequestListModal.search=''">
                        <span [ngSwitch]="showSearch">
                            <p *ngSwitchCase="false">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.997"
                                    viewBox="0 0 20 19.997">
                                    <path id="search"
                                        d="M21.7,20.29,17.99,16.61A8.992,8.992,0,1,0,16.6,18l3.678,3.68A.993.993,0,1,0,21.7,20.29ZM10.995,18a7,7,0,1,1,7-7,7,7,0,0,1-7,7Z"
                                        transform="translate(-1.979 -1.979)" fill="#8479ac" />
                                </svg>
                            </p>
                            <p *ngSwitchCase="true">
                                <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998"
                                    viewBox="0 0 13.998 13.998">
                                    <path id="close-btn"
                                        d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
                                        transform="translate(5.82 13.32)" fill="#bbb" />
                                </svg>
                            </p>
                        </span>
                    </a>

                    <button mat-button class="btnLight_fill" (click)="showFilter=!showFilter">


                        <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                <path id="filter"
                                    d="M15.6,2H4.4A2.4,2.4,0,0,0,2,4.4v.936a2.4,2.4,0,0,0,.2.96v.048a2.248,2.248,0,0,0,.472.688l4.928,4.9V17.2a.8.8,0,0,0,1.16.712l3.2-1.6a.8.8,0,0,0,.44-.712V11.928l4.9-4.9a2.248,2.248,0,0,0,.472-.688V6.3A2.4,2.4,0,0,0,18,5.336V4.4A2.4,2.4,0,0,0,15.6,2Zm-4.568,9.032a.8.8,0,0,0-.232.568v3.5l-1.6.8V11.6a.8.8,0,0,0-.232-.568L6.3,8.371,4.728,6.8H15.272ZM16.4,5.2H3.6V4.4a.8.8,0,0,1,.8-.8H15.6a.8.8,0,0,1,.8.8Z"
                                    transform="translate(-2 -2)" fill="#70639e" />
                            </svg>{{'filter.filter' | translate}}</span> <svg xmlns="http://www.w3.org/2000/svg"
                            width="9" height="5" viewBox="0 0 9 5">
                            <path id="arrow"
                                d="M15.5,9.112a.9.9,0,0,0-1.2,0l-3.065,2.834L8.211,9.112a.9.9,0,0,0-1.2,0,.766.766,0,0,0,0,1.137l3.62,3.394a.894.894,0,0,0,1.212,0L15.5,10.249a.766.766,0,0,0,0-1.137Z"
                                transform="translate(-6.754 -8.879)" fill="#70639e" />
                        </svg>
                    </button>
                    <button mat-button class="btn_fill" *ngIf="UsedBySelector"
                        (click)="SubmitRequest()">{{'items-requests.SUBMIT REQUEST' | translate}} </button>
                </div>
            </div>
        </div> -->

        <div class="page-filters webView">
            <div class="sort-item">
                <div class="count-item">
                    <span class="counter"> {{ total }} </span>
                    <span *ngIf="RequestListModal.status == 'new'" class="title">{{'items-requests.New' |
                        translate}}</span>
                    <span *ngIf="RequestListModal.status == 'approved'" class="title">{{'bidders.Approved' |
                        translate}}</span>
                    <span *ngIf="RequestListModal.status == 'rejected'" class="title">{{'bidders.Declined' |
                        translate}}</span>
                    {{'items-requests.Request' | translate}}
                </div>
                <label>{{'filter.sortBy' | translate}}:</label>
                <button mat-button class="btnLight_fill" [matMenuTriggerFor]="menu">{{sortByText|translate}} <svg
                        xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5">
                        <path id="arrow"
                            d="M15.5,9.112a.9.9,0,0,0-1.2,0l-3.065,2.834L8.211,9.112a.9.9,0,0,0-1.2,0,.766.766,0,0,0,0,1.137l3.62,3.394a.894.894,0,0,0,1.212,0L15.5,10.249a.766.766,0,0,0,0-1.137Z"
                            transform="translate(-6.754 -8.879)" fill="#70639e" />
                    </svg>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item *ngFor="let item of sortingList" (click)="OnSelectSort(item)">{{item.key
                        |translate}}</button>
                </mat-menu>
            </div>
            <div class="filters-container">
                <a (click)="onCancelSearch()">
                    <span [ngSwitch]="showSearch">
                        <p *ngSwitchCase="false">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.997" viewBox="0 0 20 19.997">
                                <path id="search"
                                    d="M21.7,20.29,17.99,16.61A8.992,8.992,0,1,0,16.6,18l3.678,3.68A.993.993,0,1,0,21.7,20.29ZM10.995,18a7,7,0,1,1,7-7,7,7,0,0,1-7,7Z"
                                    transform="translate(-1.979 -1.979)" fill="#8479ac" />
                            </svg>
                        </p>
                        <p *ngSwitchCase="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998"
                                viewBox="0 0 13.998 13.998">
                                <path id="close-btn"
                                    d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
                                    transform="translate(5.82 13.32)" fill="#bbb" />
                            </svg>
                        </p>
                    </span>
                </a>
                <button (click)="showFilter = !showFilter" mat-button [ngClass]="{ active: showFilter }"
                    class="btn dropdown-custom dropdown-toggle">
                    <!-- <img alt="Hello Khaled" src="../../../../../assets/images/icons/filter-icon.svg" /> -->
                    <span>{{'filter.filter' | translate}}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                        <path id="filter"
                            d="M15.6,2H4.4A2.4,2.4,0,0,0,2,4.4v.936a2.4,2.4,0,0,0,.2.96v.048a2.248,2.248,0,0,0,.472.688l4.928,4.9V17.2a.8.8,0,0,0,1.16.712l3.2-1.6a.8.8,0,0,0,.44-.712V11.928l4.9-4.9a2.248,2.248,0,0,0,.472-.688V6.3A2.4,2.4,0,0,0,18,5.336V4.4A2.4,2.4,0,0,0,15.6,2Zm-4.568,9.032a.8.8,0,0,0-.232.568v3.5l-1.6.8V11.6a.8.8,0,0,0-.232-.568L6.3,8.371,4.728,6.8H15.272ZM16.4,5.2H3.6V4.4a.8.8,0,0,1,.8-.8H15.6a.8.8,0,0,1,.8.8Z"
                            transform="translate(-2 -2)" fill="#70639e" />
                    </svg>
                </button>
                <div class="create-item">
                    <button (click)="SubmitRequest()" mat-button class="btn_fill" *ngIf="UsedBySelector">
                        <span> {{'items-requests.SUBMIT REQUEST' | translate}}</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="page-filters mobileView">
            <div class="count-item d-block">
                <span class="counter"> {{ total }} </span>
                <span *ngIf="RequestListModal.status == 'new'" class="title">{{'items-requests.New' |
                    translate}}</span>
                <span *ngIf="RequestListModal.status == 'approved'" class="title">{{'bidders.Approved' |
                    translate}}</span>
                <span *ngIf="RequestListModal.status == 'rejected'" class="title">{{'bidders.Declined' |
                    translate}}</span>
                {{'items-requests.Request' | translate}}
            </div>

            <div class="sort-item">
                <button mat-button class="btnLight_fill" [matMenuTriggerFor]="menu">{{sortByText|translate}} <svg
                        xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5">
                        <path id="arrow"
                            d="M15.5,9.112a.9.9,0,0,0-1.2,0l-3.065,2.834L8.211,9.112a.9.9,0,0,0-1.2,0,.766.766,0,0,0,0,1.137l3.62,3.394a.894.894,0,0,0,1.212,0L15.5,10.249a.766.766,0,0,0,0-1.137Z"
                            transform="translate(-6.754 -8.879)" fill="#70639e" />
                    </svg>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item *ngFor="let item of sortingList" (click)="OnSelectSort(item)">{{item.key
                        |translate}}</button>
                </mat-menu>
                <a (click)="onCancelSearch()">
                    <span [ngSwitch]="showSearch">
                        <p *ngSwitchCase="false">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.997" viewBox="0 0 20 19.997">
                                <path id="search"
                                    d="M21.7,20.29,17.99,16.61A8.992,8.992,0,1,0,16.6,18l3.678,3.68A.993.993,0,1,0,21.7,20.29ZM10.995,18a7,7,0,1,1,7-7,7,7,0,0,1-7,7Z"
                                    transform="translate(-1.979 -1.979)" fill="#8479ac" />
                            </svg>
                        </p>
                        <p *ngSwitchCase="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998"
                                viewBox="0 0 13.998 13.998">
                                <path id="close-btn"
                                    d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
                                    transform="translate(5.82 13.32)" fill="#bbb" />
                            </svg>
                        </p>
                    </span>
                </a>
            </div>
            <div class="filters-container">

                <button (click)="showFilter = !showFilter" mat-button [ngClass]="{ active: showFilter }"
                    class="btn dropdown-custom dropdown-toggle">
                    <!-- <img alt="" src="../../../../../assets/images/icons/filter-icon.svg" /> -->
                    <span>{{'filter.filter' | translate}}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                        <path id="filter"
                            d="M15.6,2H4.4A2.4,2.4,0,0,0,2,4.4v.936a2.4,2.4,0,0,0,.2.96v.048a2.248,2.248,0,0,0,.472.688l4.928,4.9V17.2a.8.8,0,0,0,1.16.712l3.2-1.6a.8.8,0,0,0,.44-.712V11.928l4.9-4.9a2.248,2.248,0,0,0,.472-.688V6.3A2.4,2.4,0,0,0,18,5.336V4.4A2.4,2.4,0,0,0,15.6,2Zm-4.568,9.032a.8.8,0,0,0-.232.568v3.5l-1.6.8V11.6a.8.8,0,0,0-.232-.568L6.3,8.371,4.728,6.8H15.272ZM16.4,5.2H3.6V4.4a.8.8,0,0,1,.8-.8H15.6a.8.8,0,0,1,.8.8Z"
                            transform="translate(-2 -2)" fill="#70639e" />
                    </svg>
                </button>
                <div class="create-item">
                    <button (click)="SubmitRequest()" mat-button class="btn_fill" *ngIf="UsedBySelector">
                        <span> {{'items-requests.SUBMIT REQUEST' | translate}}</span>
                    </button>
                </div>
            </div>
        </div>



        <div class="row filter-section" *ngIf="showFilter">

            <div class="col-md-9 col-12">
                <div class="d-inline">
                    <mat-form-field appearance="outline" class="mb-2 ">
                        <mat-label>{{'items-requests.Created From' | translate}}</mat-label>
                        <input matInput [max]="RequestListModal.created_to" [matDatepicker]="picker1"
                            [(ngModel)]="RequestListModal.created_from">
                        <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1>
                            <mat-datepicker-actions>
                                <button mat-button matDatepickerCancel>{{'Auction Item.Cancel' | translate}}</button>
                                <button mat-button color="primary" matDatepickerApply
                                    (click)="GetRequests()">{{'bidders.Apply' | translate}}</button>
                            </mat-datepicker-actions>
                        </mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="mb-2 ">
                        <mat-label>{{"items-requests.Created To"|translate}}</mat-label>
                        <input matInput [min]="RequestListModal.created_from" [matDatepicker]="picker"
                            [(ngModel)]="RequestListModal.created_to">
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker>
                            <mat-datepicker-actions>
                                <button mat-button matDatepickerCancel>{{'Auction Item.Cancel' | translate}}</button>
                                <button mat-button color="primary" matDatepickerApply
                                    (click)="GetRequests()">{{'bidders.Apply' | translate}}</button>
                            </mat-datepicker-actions>
                        </mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="mb-2 ">
                        <mat-label>{{"items-requests.Category"|translate}}</mat-label>
                        <mat-select [(ngModel)]="RequestListModal.category_id" (ngModelChange)="GetRequests()"
                            name="item">
                            <mat-option *ngFor="let item of categoriesList" [value]="item.id">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- <form (submit)=" onGetSearchBiddersList(true)"> -->

                    <mat-form-field appearance="outline" *ngIf="!UsedBySelector" class="mb-2 ">
                        <mat-label>{{'items-requests.Creator Name' | translate}}</mat-label>
                        <input type="text" placeholder="{{'items-requests.Search by name' | translate}} ..."
                            aria-label="Creator" matInput [(ngModel)]="BiddersModal.search"
                            [ngModelOptions]="{standalone:true}" [matAutocomplete]="auto"
                            (keyup.enter)="onGetSearchBiddersList(true)">
                        <mat-icon matSuffix (click)="onGetSearchBiddersList(true)">search</mat-icon>

                        <mat-autocomplete #auto="matAutocomplete">
                            <div style="height: 100%;overflow-y: scroll;" (scrolled)="onGetSearchBiddersList(false)"
                                [infiniteScrollDistance]="2" [infiniteScrollThrottle]="BidderPageCount"
                                [scrollWindow]="false" infiniteScroll><mat-option *ngFor="let option of BiddersList"
                                    [value]="(option.firstname + ' ' + option.lastname)|titlecase"
                                    (click)="RequestListModal.created_by = option.id;GetRequests()">
                                    {{(option.firstname + " " + option.lastname)|titlecase}}
                                </mat-option>
                                <mat-option disabled *ngIf="!BiddersList.length">{{'items-requests.Not found data' |
                                    translate}}</mat-option>
                            </div>
                        </mat-autocomplete>
                    </mat-form-field>
                    <!-- </form> -->
                </div>
            </div>
            <div class="col-md-3 col-12">
                <div class="group_btn">
                    <!-- <button mat-button class="btn_fill" (click)="GetRequests()">Apply</button> -->
                    <button mat-button class="btnLight_fill"
                        (click)="onClearFiltrs()">{{'items-requests.Clear'|translate}}</button>
                </div>
            </div>
        </div>
        <div class="search_bar row" *ngIf="showSearch">
            <form class="col-md-10 col-sm-8 col-8" *ngIf="showSearch"
                (ngSubmit)="RequestListModal.page=0;GetRequests()">
                <mat-form-field appearance="fill" class="w-100">
                    <mat-label>{{'Home.Search' | translate}}</mat-label>
                    <input type="text" [(ngModel)]="RequestListModal.search" [ngModelOptions]="{standalone:true}"
                        matInput placeholder="">
                    <mat-icon mat-button matSuffix (click)="RequestListModal.page=0;GetRequests()">search</mat-icon>
                </mat-form-field>
            </form>
            <button mat-button class="btnLight_fill col-md-2 col-sm-4 col-4"
                (click)="RequestListModal.search='';RequestListModal.page=0;GetRequests()">{{"items-requests.Clear"|translate}}</button>
        </div>
    </div>
    <div class="list" *ngIf="!loadingData">
        <ng-container *ngIf="RequestList?.length; else elseTemplate">

            <div class="container-fluid p-0" *ngFor="let item of RequestList">
                <div class="auction_item_card row p-0">
                    <div class="image col-md-4 col-12" (click)="OnNavigate(item.id)">
                        <img [src]="item.main_image" onerror="this.src='assets/images/default-img.png'" alt="">
                    </div>
                    <div class="text col-md-8 col-12">
                        <div>
                            <span class="Unpublished" *ngIf="!item.is_published && RequestListModal.status=='approved'">
                                {{'items-requests.Unpublished' | translate}}</span>
                            <div class="title" (click)="OnNavigate(item.id)"> {{item?.name}}</div>
                        </div>

                        <!-- <div class="desc">{{item?.description}}</div> -->
                        <div class="category">
                            <p class="room_name" *ngIf="item?.room">
                                <img src="./assets/images/icons/roomName.svg" alt="" srcset="">
                                {{item?.room?.name || item?.room_name}}
                            </p>
                        </div>
                        <div class="category">
                            <p><img src="./assets/images/icons/category.svg" alt="" srcset="">
                                {{item?.category?.name}}
                            </p>
                        </div>
                        <!-- <div class="mb-2">
                            <span [ngSwitch]="item.is_published">
                                <p *ngSwitchCase="1" class="published">
                                    Published
                                </p>
                                <p *ngSwitchCase="0" class="unpublished">
                                    Unpublished
                                </p>
                                <p *ngSwitchDefault class="unpublished">
                                    Unpublished
                                </p>
                            </span>
                        </div> -->
                        <div class="requestTiming d-flex align-items-center justify-content-start">
                            <div class="time" *ngIf="item?.start_date!='1970-01-01T00:00:00Z'"><img
                                    src="./assets/images/icons/clock.svg" alt="" srcset="">
                                {{item?.start_date |dateUTC :"hh:mm a"}}
                                <ng-container *ngIf="item?.end_at">
                                    - {{item?.end_date |dateUTC :"hh:mm a"}}

                                </ng-container>

                            </div>
                            <div *ngIf="item?.start_date!='1970-01-01T00:00:00Z'" class="time ms-4"><img
                                    src="./assets/images/icons/calender.svg" alt="" srcset="">
                                {{item?.start_date |dateUTC:'LL'}}
                            </div>

                        </div>

                        <div class="footer row">
                            <div class="start_cost"
                                [ngClass]="{'col-md-6 col-12': RequestListModal.status=='approved'}">
                                <p>{{("Main Auction.Starting bid"|translate)}}</p>
                                <div><span>{{"Main Auction.SR"|translate}}</span>
                                    <strong>{{(item?.minimum_price|number)}}</strong>
                                </div>
                            </div>
                            <div class="timer col-md-6 col-12" *ngIf="RequestListModal.status=='approved'">
                                <ng-container [ngSwitch]="item?.type">
                                    <ng-container *ngSwitchCase="'upcoming'">
                                        <timer [Mode]="'light'" type="date" [time]="item?.remaining_time"
                                            [startORend]="1">
                                        </timer>
                                    </ng-container>


                                    <ng-container *ngSwitchCase="'ongoing'">
                                        <ng-container *ngIf="authUserIsAdmin; else elseTemplate3">
                                            <div class="d-flex justify-content-center align-items-center"
                                                *ngIf="item?.is_reserve_time_started">
                                                <div class="auction-badge" style="max-height: fit-content;">
                                                    <div class="badge-text">
                                                        <p class="head">{{'Auction Item.The auction has ended' |
                                                            translate}}</p>
                                                        <p class="name">{{'items-requests.Reserve price not met' |
                                                            translate}}</p>
                                                    </div>
                                                    <app-auction-end-count-down [TotalTime]="120"
                                                        [RemainingTime]="item?.remaining_minutes_for_reserve ||0" [
                                                        TimerMode="minute"></app-auction-end-count-down>
                                                </div>

                                            </div>

                                            <timer [Mode]="'light'" type="date" [time]="item?.remaining_time"
                                                *ngIf="!item?.is_reserve_time_started" [startORend]="2">
                                            </timer>
                                        </ng-container>
                                        <ng-template #elseTemplate3>
                                            <div class="d-flex justify-content-center align-items-center"
                                                *ngIf="item?.is_reserve_time_started&&item?.is_me_last_bidder">

                                                <app-auction-end-count-down style="width: 75px;height: 75px;"
                                                    [TotalTime]="120"
                                                    [RemainingTime]="item?.remaining_minutes_for_reserve ||0"
                                                    TimerMode="minute"></app-auction-end-count-down>

                                                <div class="auction-badge">
                                                    <div class="badge-text">
                                                        <p class="head">{{'Auction Item.The auction has ended' |
                                                            translate}}</p>
                                                        <p class="name">{{'items-requests.Reserve price not met' |
                                                            translate}}</p>
                                                    </div>

                                                </div>

                                            </div>

                                            <div class="auction-badge"
                                                *ngIf="item?.is_reserve_time_started&&!item?.is_me_last_bidder">
                                                <div class="badge-text">
                                                    <p class="head">{{'Auction Item.The auction has ended' | translate}}
                                                    </p>
                                                    <p class="name">{{"Auction Item.You're not the winning bidder" |
                                                        translate}} </p>
                                                </div>
                                            </div>

                                            <timer [Mode]="'light'" type="date" [time]="item?.remaining_time"
                                                *ngIf="!item?.is_reserve_time_started" [startORend]="2">
                                            </timer>


                                        </ng-template>

                                    </ng-container>


                                    <ng-container *ngSwitchCase="'completed'">
                                        <!-- When Auction Compeleted according to Admin -->
                                        <ng-container
                                            *ngIf="authUserIsAdmin && item.hasOwnProperty('is_has_winner'); else elseTemplate3">
                                            <div class="auction-badge" *ngIf="item?.is_has_winner">

                                                <div class="badge-img rounded-circle" style="overflow: hidden;">
                                                    <img *ngIf="item?.winner?.image" [src]="item?.winner?.image"
                                                        (error)='item?.winner.image = ""'>
                                                    <span *ngIf="!item?.winner?.image">
                                                        {{(item?.winner?.firstname+'
                                                        '+item?.winner?.lastname)|
                                                        shortName }}</span>
                                                </div>
                                                <div class="badge-text">
                                                    <p class="head">{{'items-requests.Auction winner' | translate}}</p>
                                                    <p class="name">{{(item?.winner?.firstname + ' '
                                                        +item?.winner?.lastname ) | titlecase }} </p>
                                                </div>
                                            </div>

                                            <div class="auction-badge" *ngIf="!item?.is_has_winner">
                                                <div class="badge-text">
                                                    <p class="head">{{'Auction Item.The auction has ended' | translate}}
                                                    </p>
                                                    <p class="name">{{'items-requests.With No Winner' | translate}} </p>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <!-- When Auction Compeleted according to user -->
                                        <ng-template #elseTemplate3>
                                            <ng-container
                                                *ngIf="item.hasOwnProperty('is_me_winner'); else elseTemplate4">
                                                <div class="auction-badge" *ngIf="!item?.is_me_winner">
                                                    <div class="badge-text">
                                                        <p class="head">{{'Auction Item.The auction has ended' |
                                                            translate}}</p>
                                                        <p class="name">{{"Auction Item.You're not the winning bidder" |
                                                            translate}}</p>
                                                    </div>
                                                </div>

                                                <div class="auction-badge" *ngIf="item?.is_me_winner">
                                                    <div class="badge-text">
                                                        <p class="head">{{'Auction Item.The auction has ended' |
                                                            translate}}</p>
                                                        <p class="name">{{"items-requests.You're the winner" |
                                                            translate}} </p>
                                                    </div>
                                                </div>
                                            </ng-container>

                                            <ng-template #elseTemplate4>
                                                <timer [Mode]="'light'" type="date"
                                                    [time]=" item?.start_at==null?0: item?.remaining_time"
                                                    [startORend]="2">
                                                </timer>
                                            </ng-template>

                                        </ng-template>


                                    </ng-container>
                                    <ng-container *ngSwitchDefault>

                                    </ng-container>

                                </ng-container>
                            </div>

                            <div class="col-12" *ngIf="item?.request_by && RequestListModal.status!='approved'">
                                <div class="requestBy row">
                                    <div class="info-badge bg-transparent p-0 col-md-6 col-12 overflow-hidden">
                                        <div class="badge-img rounded-circle">
                                            <img *ngIf="item?.request_by.image" [src]="item?.request_by.image"
                                                (error)='item?.request_by.image = ""'>
                                            <span *ngIf="!item?.request_by.image">
                                                {{item?.request_by.firstname +" "+ item?.request_by.lastname | shortName
                                                }}</span>
                                        </div>
                                        <div class="badge-text">
                                            <span class="label">{{'bidders.Requested by' | translate}}</span>
                                            <p>{{item?.request_by.firstname +" "+ item?.request_by.lastname |titlecase}}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="info-badge bg-transparent p-0 col-md-6 col-12 overflow-hidden">
                                        <div class="badge-text ps-2">
                                            <span class="label">{{'bidders.Request submitted on' | translate}}</span>
                                            <p>{{item?.created_at |dateUTC}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="mt-3">
                <div class="text-center" *ngIf="RequestListModal.status=='new'">
                    <mat-paginator class="mt-3" [length]="FilterItems[0].count" (page)="handlePageEvent($event)"
                        [pageSize]="this.RequestListModal.perPage" [pageSizeOptions]="[10,20,50]"
                        [pageIndex]="this.RequestListModal.page" aria-label="Select page">
                    </mat-paginator>
                </div>

                <div class="text-center" *ngIf="RequestListModal.status=='approved'">
                    <mat-paginator class="mt-3" [length]="FilterItems[1].count" (page)="handlePageEvent($event)"
                        [pageSize]="this.RequestListModal.perPage" [pageSizeOptions]="[10,20,50]"
                        [pageIndex]="this.RequestListModal.page" aria-label="Select page">
                    </mat-paginator>
                </div>

                <div class="text-center" *ngIf="RequestListModal.status=='rejected'">
                    <mat-paginator class="mt-3" [length]="FilterItems[2].count" (page)="handlePageEvent($event)"
                        [pageSize]="this.RequestListModal.perPage" [pageSizeOptions]="[10,20,50]"
                        [pageIndex]="this.RequestListModal.page" aria-label="Select page">
                    </mat-paginator>
                </div>
            </div>


        </ng-container>
        <ng-template #elseTemplate>
            <div class="no-data">
                <img src="assets/images/Auctions_no_data.svg" alt="">
                <h4>{{'items-requests.No requests submitted' | translate}}</h4>
                <p>{{'items-requests.As a valued participant in our bidding process.' | translate}} <br>
                    {{'items-requests.We want you to know' | translate}} </p>
                <!-- <p>We want you to know that we are open to receiving requests for items to include in our
                    auctions..</p> -->
                <button mat-button class="btn_fill" (click)="SubmitRequest()" *ngIf="UsedBySelector">
                    {{'items-requests.Submit Request' | translate}} </button>
            </div>
        </ng-template>
    </div>
    <app-loading *ngIf="loadingData"></app-loading>
</div>